import React from "react";
import Popupz from "../../atoms/Popupz";
import { useDispatch } from "react-redux";
import { hidePopup } from "../../../redux/actions";
import Buttonz from "../../atoms/Buttonz";
import SvgIcn from "../../../data/IconCompo";

const CongratsPopup = () => {
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(hidePopup());
    // Scroll to top smoothly
    window.location = "/";
  };

  return (
    <Popupz 
    onClose={handleClose} 
    className="congrats-popup"
    title="Congratulations!"
    text={<>
         Welcome to our community! <br/>
         Your account has been successfully created.     
      </>}
    >
        <Buttonz 
                  iconR="login"
                  hoverR="login"
                  label="Get Started"
        onClick={handleClose} />

    </Popupz>

    



  );
};

export default CongratsPopup;


